module.exports = __webpack_public_path__ + "img/avatar5.8ce2bb26.png";